import { paramCase } from 'change-case'
import { oneOf, string, object, func, bool, array } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import { MobileSingle, DesktopNewsFeed, DesktopTimeline } from './display'
import { baseStyles } from './styles'

const displays = {
  mobileSingle: MobileSingle,
  desktopTimeline: DesktopTimeline,
  desktopNewsFeed: DesktopNewsFeed,
  default: MobileSingle,
}

const matchDisplay = (display) => displays[display] || displays.default

export const FacebookStandard = ({
  accountImage,
  accountName,
  assets,
  collabEnabled,
  collabAccount,
  content,
  display,
  isPresenting = false,
  linksWithData,
  onExpandAsset = () => null,
  onRemoveAsset = () => null,
  onShowAssetPicker = () => null,
  readOnly = false,
  scheduledAt,
  timezone,
  truncate,
  updateAssets = () => null,
  updateCaption = () => null,
  updateLinkData = () => null,
  updateText = () => null,
}) => {
  const RenderDisplay = matchDisplay(display)

  return (
    <div
      css={baseStyles(display)}
      className={kuiperClassNames(
        'facebook facebook-facebook-standard',
        `facebook-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountName={accountName}
        assets={assets}
        collabEnabled={collabEnabled}
        collabAccount={collabAccount}
        content={content}
        linksWithData={linksWithData}
        isPresenting={isPresenting}
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
        onShowAssetPicker={onShowAssetPicker}
        readOnly={readOnly}
        scheduledAt={scheduledAt}
        truncate={truncate}
        onAssetChange={(val) => updateAssets(val)}
        onContentChange={(val) => updateText(val, 'content')}
        onLinkDataUpdate={(val, name, link) => updateLinkData(val, name, link)}
        updateCaption={(val, assetId) => updateCaption(val, assetId)}
        timezone={timezone}
      />
    </div>
  )
}

FacebookStandard.propTypes = {
  accountImage: object,
  accountName: string,
  assets: array,
  collabEnabled: bool,
  collabAccount: string,
  content: string,
  display: oneOf(['mobileSingle', 'desktopTimeline', 'desktopNewsFeed']),
  isPresenting: bool,
  linksWithData: array,
  onExpandAsset: func,
  onRemoveAsset: func,
  onShowAssetPicker: func,
  readOnly: bool,
  scheduledAt: string,
  timezone: string,
  truncate: bool,
  updateAssets: func,
  updateCaption: func,
  updateLinkData: func,
  updateText: func,
}
